import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {ExternalLink} from '../models/external-link';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';

@Injectable({ providedIn: 'root' })
export class ExternalLinksService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'ExternalLinksService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(clientId: string): Observable<SendBackResult<ArrayResponse<ExternalLink>>> {
    return this.get<ArrayResponse<ExternalLink>>(`/clients/${clientId}/applications/allowed`);
  }
}
